function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 19c-.3 0-.5-.1-.7-.3-.3-.2-.4-.6-.3-.9l.8-3.3c0-.2.1-.3.3-.5L14.3 3.8c.8-.8 2-1 3-.6.3.1.6.3.9.6.3.3.5.6.6.9s.2.7.2 1-.1.7-.2 1c-.1.3-.3.6-.6.9L8 17.9c-.1.1-.3.2-.5.3l-3.3.8H4zm1.7-3.8l-.3 1.4 1.4-.3 10-10 .2-.2v-.4c0-.1 0-.2-.1-.3 0-.1-.1-.2-.2-.2l-.2-.2c-.3-.1-.6 0-.8.2l-10 10z"
});
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref);
}
export default SvgEdit;